import React from "react";
import { Box, Search, TextField, Button } from "./styles";
import { Search as SearchIcon } from "@mui/icons-material";

export interface SearchProps {
  value: string;
  textHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  removeHandler: () => void;
  action: () => void;
  keyHandler: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchComponent = ({
  value,
  textHandler,
  removeHandler,
  action,
  keyHandler,
}: SearchProps) => {
  return (
    <Box>
      <Search>
        <TextField
          placeholder="Search by edited user "
          value={value}
          onChange={textHandler}
        />
        <Button onClick={action}>
          <SearchIcon sx={{ color: "#21005D" }} />
        </Button>
      </Search>
    </Box>
  );
};

export default SearchComponent;
